import { Box, Skeleton } from "@mui/material";

export default function SettingsSkeleton() {
  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 3,
        bgcolor: "rgba(249,250,251,0.6)",
        display: "flex",
        gap: 3,
        alignItems: "center",
      }}
    >
      <Box sx={{ width: 180 }}>
        <Skeleton width={120} height={20} />
        <Skeleton width={90} height={14} sx={{ mt: 1 }} />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Skeleton width="100%" height={36} />
      </Box>

      <Box sx={{ width: 120, textAlign: "right" }}>
        <Skeleton width={80} height={36} />
      </Box>
    </Box>
  );
}
